import { post, get, put, createApiUrl } from './baseApi';

// 입금 관련
export function putDeposit(deposit) {
    const request = createApiUrl("/api/v1/admin/user/cash/deposit");
    return put(request, deposit);
}

export function cancelDeposit(deposit) {
    const request = createApiUrl("/api/v1/admin/user/cash/deposit/cancel");
    return put(request, deposit);
}

export function getRequestDepositList(params) {
    const request = createApiUrl("/api/v1/admin/user/cash/deposit/request/list");
    return post(request, params);
}

export function getDepositList(params) {
    const request = createApiUrl("/api/v1/admin/user/cash/deposit/list");
    return post(request, params);
}

// 출금 관련
export function putWithdraw(withdraw) {
    const request = createApiUrl("/api/v1/admin/user/cash/withdraw");
    return put(request, withdraw);
}

export function getRequestWithdrawList(params) {
    const request = createApiUrl("/api/v1/admin/user/cash/withdraw/request/list");
    return post(request, params);
}

export function getWithdrawList(params) {
    const request = createApiUrl("/api/v1/admin/user/cash/withdraw/list");
    return post(request, params);
}

// 현금/포인트 처리
export function postMoney(money) {
    const request = createApiUrl("/api/v1/admin/cash/post");
    return post(request, money);
}

export function postPoint(point) {
    const request = createApiUrl("/api/v1/admin/point/post");
    return post(request, point);
}

// 현금/포인트 이력
export function getUserCashList(params) {
    const request = createApiUrl("/api/v1/admin/cash/list");
    return post(request, params);
}

export function getUserPointList(params) {
    const request = createApiUrl("/api/v1/admin/user/point/list");
    return post(request, params);
}

// 통합 잔액 조회
export function getUnifiedBalance(companyCode, userId) {
    const request = createApiUrl("/api/v1/casino/balance/unified");
    return get(request, { companyCode, userId });
}

// 통합 트랜스퍼 잔액 출금
export function unifiedWithdraw(params) {
    const request = createApiUrl("/api/v1/casino/withdraw/unified");
    return post(request, params);
}
